// src/services/stockAlignment.ts
//
// Client for /api/agent/align-stock. Auth + URL pattern matches
// stockShapeSuggestions.ts. Per CLAUDE.md: no silent fallbacks — non-2xx
// responses throw.

import { getAgentUrl } from './agent-url'
import { authHeaders } from './auth-headers'

export interface PartPlacement {
  /** Translation in mm relative to the stock center. */
  position: [number, number, number]
  /** Euler XYZ rotation in radians. */
  rotation: [number, number, number]
}

export interface AlignmentResult {
  placement: PartPlacement
  fits: boolean
  reason: string
  confidence?: 'high' | 'medium' | 'low'
}

/**
 * Asks the backend to align `partGeometry` inside `stockGeometry`.
 * Both geometries should be `ExtractedGeometry` blobs from /api/analyze-files.
 */
export async function fetchStockAlignment(
  stockGeometry: Record<string, unknown>,
  partGeometry: Record<string, unknown>,
): Promise<AlignmentResult> {
  const res = await fetch(`${await getAgentUrl()}/api/agent/align-stock`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...await authHeaders() },
    body: JSON.stringify({ stockGeometry, partGeometry }),
  })
  if (!res.ok) {
    const detail = await res.text().catch(() => res.statusText)
    throw new Error(`Stock alignment failed (${res.status}): ${detail}`)
  }
  return res.json() as Promise<AlignmentResult>
}
